<template>
    <div>
        <div class="card__header">
            <p class="card__title">Summary</p>
        </div>
        <div class="card__content">
          <div class="card card--xs card--noShadow fill--paper">
            <div class="card__content">
              <p class="caption text--disabled">Original basket</p>
              <div class="grid grid--jcSpaceBetween" v-for="item in originalCart">
                <p class="text-16">{{ item.product_name }} x {{ item.qty }}</p>
                <p class="text-16">£{{ item.product_price * item.qty | setDecimals }}</p>
              </div>
              <p class="caption text--disabled">Additional products</p>
              <div class="grid grid--jcSpaceBetween" v-for="product in $parent.cart" v-if="product.qty > 0">
                <p>{{ product.name }} x {{ product.qty }}</p>
                <p>£{{ product.price * product.qty | setDecimals }}</p>
              </div>
              <div class="grid grid--jcSpaceBetween text--bold">
                <p>Basket total</p>
                <p>£{{ ($parent.itemsTotal / 100) | setDecimals }}</p>
              </div>
            </div>
            <div class="card__content">
              <div v-for="adjustment in $parent.adjustments" class="grid grid--jcSpaceBetween">
                <p>{{ adjustment.humanized_type }}</p>
                <p>£{{ (adjustment.amount / 100) | setDecimals }}</p>
              </div>
              <div class="grid grid--jcSpaceBetween text--bold">
                <p>Total</p>
                <p>£{{ ($parent.total / 100) | setDecimals }}</p>
              </div>
            </div>
          </div>
          <div class="form mt-3" v-if="!$parent.promotion_total">
            <div class="form__field">
              <div class="grid grid--row grid--aiCenter">
                <input type="text" class="form__control mr-1" placeholder="Enter promo code"
                      v-model="$parent.promotion_code" autocomplete="off">
                <button type="button" class="button button--md button--grey" v-on:click="$parent.validateOrder()" v-if="!$parent.loading">Apply</button>
              </div>
              <div v-if="$parent.promotion_code !== null && $parent.promotion_code !== '' && !$parent.promotion_total" class="form__notice">
                <p>Apply the code or clear the field to be able to click order</p>
              </div>
              <div v-if="$parent.promotionErrors.length && $parent.promotion_code !== null && $parent.promotion_code !== ''" class="form__notice form__notice--error">
                <p v-for="error in $parent.promotionErrors">{{ error }}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="$parent.loading">
            <popup-loader></popup-loader>
        </div>
        <div class="card__actions">
            <button type="button" class="button button--md button--grey" v-on:click="$parent.step = 'NEW'">Back</button>
            <button type="button" class="button button--md button--secondary" :disabled="$parent.promotion_code !== null && $parent.promotion_code !== '' && !$parent.promotion_total" v-on:click="nextStep()" v-if="!$parent.loading">{{ nextLabel }}</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            price: 0,
            nextLabel: 'Next',
            originalCart: []
        }
    },

    beforeMount() {
      this.$parent.order.items.forEach((item) => {
        item = { ...item }; // clone item object
        let extraProduct = this.$parent.order.extra_products.find((extra) => extra.product_id === item.product_id);

        if (extraProduct) {
          item.qty -= extraProduct.qty;
        }

        if (item.qty > 0) {
          this.originalCart.push(item);
        }
      });

      this.$parent.validateOrder();

      if (this.$root.user.has_payment_method) {
          this.nextLabel = 'Order';
      }

    },

    methods: {
        nextStep() {
            this.$parent.items = [];

            // Set cart items
            $.each(this.$parent.cart, (index, product) => {
                if (product.qty > 0) {
                  if (this.$parent.isRecurring) {
                    this.$parent.items.push({
                      product_id: product.id,
                      qty: product.qty + product.base_qty,
                      //selected: product.qty,
                      //base: product.base_qty
                    });
                  }
                  else {
                    this.$parent.items.push({
                      product_id: product.id,
                      qty: product.qty
                    });
                  }
                }
            });

            if (this.$root.user.has_payment_method) {
                this.$parent.sendOrder();
            } else {
                this.$parent.step = 'PAYMENT';
            }

        }
    },

    computed: {
        config() {
            return window.config;
        }
    }
}
</script>
